import React, { useEffect, useRef } from "react";
import s from "./Title.module.css";
import { getFormattedDate } from "../../utils";

export const Title = ({ date, name, title, logoSrc, color, ...props }) => {
  const nameRef = useRef();

  useEffect(() => {
    if (color !== undefined) nameRef.current.style.color = color;
  }, []);

  return (
    <div className={s.title} style={{ position: "relative" }}>
      <img className={s.mssLogo} src={logoSrc} alt={"MOTORSPORT STATS"} />
      {date !== undefined && <p className={s.raceDate + " apply-font"}>{getFormattedDate(date).toUpperCase()}</p>}
      <p className={s.raceFullName + " apply-font"} ref={nameRef}>
        {name.toUpperCase()}
      </p>
      <h2 className={s.chartTitle + " apply-font"}>{title.toUpperCase()}</h2>
    </div>
  );
};
